import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  CheckboxProps,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Tooltip,
} from "@mui/material";
import { red, blue } from "@mui/material/colors";
import React from "react";
import { Factions } from "../../../enums/factions.enum";
import { Races } from "../../../enums/races.enum";
import { maskContainsBit } from "../../../functions/bits.functions";
import { races } from "./races";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { ClickableTooltip } from "../../molecules";
import styled from "styled-components";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

const RaceMask = () => {
  const [mask, setMask] = React.useState<number>(0);

  const handleChange = (e: any) => {
    const { value: race, checked: userChecked } = e.target;
    const bit = 1 << (race - 1);
    setMask(userChecked ? mask | bit : mask & ~bit);
  };

  const handleInput = (e: any) => {
    const { value: input } = e.target;
    const isValid = input >= 0 && input <= 1 << Races.MURGOLOC;
    setMask(isValid ? input : 0);
  };

  const addAlly = () => setMask(mask | 214093);
  const addHorde = () => setMask(mask | 11186);
  const resetMask = () => setMask(0);

  const raceAlly = races.filter(({ faction }) => faction === Factions.ALLIANCE);
  const raceHorde = races.filter(({ faction }) => faction === Factions.HORDE);
  return (
    <Card sx={{ width: 472 }}>
      <CardHeader
        subheader="Races mask Calculator"
        avatar={
          <Avatar
            sx={{ marginLeft: "8px", bgcolor: red[500] }}
            aria-label="recipe"
          >
            R
          </Avatar>
        }
        action={
          <ActionsContainer>
            <Tooltip title="Add Alliance" placement="top">
              <IconButton color="primary" component="span" onClick={addAlly}>
                <img src={"/imgs/alliance-logo.webp"} alt="Alliance Logo" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Add Horde" placement="top">
              <IconButton color="primary" component="span" onClick={addHorde}>
                <img src={"/imgs/horde-logo.webp"} alt="Horde Logo" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Reset" placement="top">
              <IconButton color="primary" component="span" onClick={resetMask}>
                <RestartAltIcon />
              </IconButton>
            </Tooltip>
          </ActionsContainer>
        }
        sx={{ "& > .MuiCardHeader-action": { alignSelf: "center" } }}
      />
      <CardContent sx={{ padding: "0 24px 24px 24px" }}>
        <InputAndCopy mask={mask} handleInput={handleInput} />

        <Grid container spacing={3}>
          <Grid item xs={6}>
            <FormGroup>
              {raceAlly.map(({ race }) => (
                <FormControlLabel
                  key={race}
                  checked={maskContainsBit(mask, 1 << (race - 1))}
                  control={<RaceCheckbox checkColor={blue} value={race} />}
                  label={Races[race]}
                  onChange={handleChange}
                />
              ))}
            </FormGroup>
          </Grid>

          <Grid item xs={6}>
            <FormGroup>
              {raceHorde.map(({ race }) => (
                <FormControlLabel
                  key={race}
                  checked={maskContainsBit(mask, 1 << (race - 1))}
                  control={<RaceCheckbox checkColor={red} value={race} />}
                  label={Races[race]}
                  onChange={handleChange}
                />
              ))}
            </FormGroup>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RaceMask;

const ActionsContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;

  & > span {
    width: 38px;
    height: 38px;

    & > img {
      width: 100%;
    }
  }
`;

const InputAndCopy = ({
  mask,
  handleInput,
}: {
  mask: number;
  handleInput: (e: any) => void;
}) => {
  return (
    <Paper
      variant="outlined"
      component="form"
      sx={{
        display: "flex",
        alignItems: "center",
        marginBottom: "16px",
        padding: "0 8px",
      }}
    >
      <InputBase
        size="small"
        sx={{ flex: 1, "& > input:first-child": { padding: 0 } }}
        value={mask}
        onChange={handleInput}
        autoFocus
      />

      <Divider sx={{ height: 24, m: 0.5 }} orientation="vertical" />

      <ClickableTooltip title="Mask copié !">
        <IconButton
          color="primary"
          size="small"
          onClick={() => navigator.clipboard.writeText(String(mask))}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </ClickableTooltip>
    </Paper>
  );
};

const RaceCheckbox = ({
  checkColor,
  ...checkboxProps
}: { checkColor: Record<string, string> } & CheckboxProps) => (
  <Checkbox
    size="small"
    sx={{
      padding: "2px 8px",
      color: checkColor[500],
      "&.Mui-checked": {
        color: checkColor[600],
      },
    }}
    {...checkboxProps}
  />
);
